/**
 * Bob Stage Route
 *
 * Triggers loading of the bob stage when this route becomes active.
 * The actual canvas is in the parent layout (ux.tsx).
 */

import { createFileRoute } from "@tanstack/react-router";
import { useLoadStageOnMount } from "../ux";

export const Route = createFileRoute("/_immersive/demo/3d/ux/bob")({
  component: BobStageRoute,
});

function BobStageRoute() {
  useLoadStageOnMount("bob");
  return null;
}
